import React, { Fragment } from 'react';
// types
import PropTypes from 'prop-types';

// redux
import { connect } from 'react-redux';

// apollo libs
import { graphql, compose, withApollo } from 'react-apollo';
import {
  offerQuery,
  offerAnonQuery,
  updateInvestorOfferViews,
  submitInvestmentMutation,
  offerInvestmentsQuery,
  loginSharedMutation,
  validateOfferPasswordMutation,
  countViewMutation,
} from '../../apollo';

// routes
import { Redirect, Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import { NavHashLink as NavLinks } from 'react-router-hash-link';

// libs
import get from 'lodash/get';
import YoutubeBackground from 'react-youtube-background';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

// shared libs
import { Loading, offerTypes } from 'entoro-shared';

// hocs
import withLayout from '../withLayout';

// components
import OfferDocuments from './OfferDocuments';
import OfferMedia from './OfferMedia';
import CompanySummary from './CompanySummary';
import ManagementTeam from './ManagementTeam';
import OfferDetails from './OfferDetails';
import AnonOfferDetails from './AnonOfferDetails';
import OfferHighlights from './OfferHighlights';
import OfferListItems from './OfferListItems';
import OfferFavorite from '../OfferFavorite';
import OfferFAQs from './OfferFAQs';
import OfferInvestments from './OfferInvestments';
import PaymentProcessAction from './ReadyToInvestButton/PaymentProcess/PaymentProcessAction';
import AnonOfferDocuments from './AnonOfferDocuments';
import AnonCompanyHighlights from './AnonCompanyHighlights';
import AnonOfferListItems from './AnonOfferListItems';
import OfferPresentation from './OfferPresentation';
import Comment from './Comments';
import CountDown from './CountDown';
import OfferPwdAction from '../Dashboard/OfferPwd/OfferPwdAction';
import OfferDetailsFund from './OfferDetailsFund';
import Footer from '../../Layouts/Footer';

// config
import { CRYPTO_COMPARE_KEY, RESTAPI_URI } from '../../config';

const JoinOfferboardCTA = () => (
  <div id='join-offerboard-cta'>
    <h3>Register for an OfferBoard Account</h3>
    <p>
      View complete offer details including Company Documents, Our Analysis and
      more with an OfferBoard account.
    </p>
    <Link to='/register' className='button small w-button'>
      Join For Free
    </Link>
  </div>
);

class OfferOverview extends React.Component {
  state = {
    tab: 0,
    openInvestment: null,
    openContinue: false,
    investmentId: null,
    showbrokerageAgreementStep: false,
    showPaymentMethodStep: false,
    showAgreementStep: false,
    isauthlogin: false,
    showPosition: false,
    numPages: null,
    pageNumber: 1,
    mainDialogOpen: false,
    showCountDown: true,
    setPaymentSteps: null,
    stripeSessionId: null,
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    //props from the parent
    const {
      updateViews,
      updateAgreementStatus,
      location: { search, pathname },
    } = this.props;

    //All URL Search Params for payment modal
    const authToken = new URLSearchParams(search).get('auth_r');
    const refTenant = new URLSearchParams(search).get('refTenant');
    const isInvestmentId = new URLSearchParams(search).get('investmentId');
    const steps = new URLSearchParams(search).get('steps');
    const stripeSessionId = new URLSearchParams(search).get('session_id');
    const type = new URLSearchParams(search).get('type');

    /** check if the type for brokerage and stripe on the url is true or false */
    const isStripe = type === 'stripe';
    const isBrokerage = type === 'brokerage';

    /** reopen the modal dialog once the return url is successfully loaded */
    if (isInvestmentId) {
      this.setState({
        openContinue: true,
        isInvestmentId,
        openInvestment: isInvestmentId,
        showPaymentMethodStep: isStripe,
        setPaymentSteps: steps,
      });
    }

    /** stripe payment functionality on after payment */
    this.handleStripeAfterPayment(
      isStripe,
      isInvestmentId,
      stripeSessionId,
      pathname
    );

    /** auto-auth for shared tenant functionality on redirection */
    if (authToken && authToken !== null && !this.props.isAuthenticated) {
      this.handleLogin(authToken, refTenant);
    }
    const { mutate } = this.props.client;

    const variables = {
      input: {
        offerId: this.props.match.params.id,
        investorUserId: this.props.investorUser._id,
      },
      investorUser: this.props.investorUser,
    };
    const { data1 } = await mutate({
      mutation: countViewMutation,
      variables,
    });

    window.addEventListener('scroll', this.handleScroll);
    updateViews();

    /** set update for brokerage and subscription agreement status */
    this.handleAgreementCallback(isBrokerage, updateAgreementStatus, pathname);
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };

  /**
   * handle login for shared tenant functionality
   * @param {*} token
   * @param {*} tenantId
   */
  handleLogin = async (token, tenantId) => {
    const { mutate } = this.props.client;
    try {
      const variables = {
        token,
        refTenantId: tenantId,
      };
      const { data } = await mutate({
        mutation: loginSharedMutation,
        variables,
      });

      localStorage.setItem('authToken', data.loginShared);
      this.setState({ isauthlogin: true });

      this.props.dispatch(push(`/offer/${this.props.match.params.id}`));
    } catch (error) {
      console.log('Error login', error);
    }
  };

  /**
   * update all the signed documents for the investment brokerage and subscription agreement status
   * @param {Boolean} isBrokerage
   * @param {*} updateAgreementStatus
   * @param {*} pathname - current pathname
   */
  handleAgreementCallback = (isBrokerage, updateAgreementStatus, pathname) => {
    //update the agreement status
    if (updateAgreementStatus) {
      let investId = null;

      updateAgreementStatus().then(({ data }) => {
        investId = data.submitInvestment._id;
      });
      this.setState({
        showAgreementStep: true,
        showbrokerageAgreementStep: isBrokerage,
      });
      window.history.replaceState({}, '', pathname);
    }
  };

  fetchPaymentStatus = async (sessionId) => {
    //close the modal dialog
    this.setState({
      openInvestment: false,
      showAgreementStep: false,
      openContinue: false,
    });

    //rest api call to fetch the payment status
    const status = await fetch(`${RESTAPI_URI}/retrievePaymentStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        stripeSessionId: sessionId,
      }),
    }).then(async (response) => {
      const res = await response.json();

      return res; //return the response of session and customer data
    });

    return status;
  };

  /**
   * Store the payment status to investment status WITH Sweet Alert
   * @param {*} investmentId
   * @param {*} investmentStatus
   */
  storePaymentStatus = async (investmentId, investmentStatus) => {
    //graphql mutation to update the payment status
    const { mutate } = this.props.client;
    const input = {
      _id: investmentId,
      offerId: this.props.match.params.id,
      ...investmentStatus,
    };

    try {
      const refetchQueries = [
        {
          query: offerInvestmentsQuery,
          variables: {
            offerId: this.props.match.params.id,
          },
        },
      ];

      const {
        data: {
          submitInvestment: { investmentStatus },
        },
      } = await mutate({
        mutation: submitInvestmentMutation,
        variables: { input },
        refetchQueries,
      });

      if (investmentStatus === 'INVESTMENT_COMPLETE') {
        //pop up the success message
        Swal.fire({
          title: 'Congratulations!',
          text: 'Your investment has been completed',
          icon: 'success',
          confirmButtonText: 'Ok',
        });
      } else {
        Swal.fire({
          title: 'Payment Verification',
          text: 'Your investment is pending payment verification',
          icon: 'info',
          confirmButtonText: 'Ok',
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  checkPaymentStatus = (paymentStatus) => {
    let investmentStatus, paymentSent;

    // switch payment status to the state
    switch (paymentStatus) {
      case 'paid':
        investmentStatus = 'INVESTMENT_COMPLETE';
        paymentSent = true;
        break;
      case 'unpaid':
        investmentStatus = 'PENDING_PAYMENT_VERIFICATION';
        paymentSent = false;
        break;
      case 'no_payment_required':
        investmentStatus = 'NOT_STARTED';
        paymentSent = false;
        break;
      default:
        break;
    }
    return { investmentStatus, paymentSent };
  };

  /**
   * Stripe payment functionality on after payment
   * @param {Boolean} isStripe
   * @param {Boolean} isInvestmentId
   * @param {String} stripeSessionId
   * @param {*} pathname - the pathname of the url
   */
  handleStripeAfterPayment = async (
    isStripe,
    isInvestmentId,
    stripeSessionId,
    pathname
  ) => {
    if (isStripe && stripeSessionId) {
      //fetch the payment status from stripe
      const {
        session: { payment_status },
      } = await this.fetchPaymentStatus(stripeSessionId);

      //check the payment status and update the investment status
      const investmentStatus = this.checkPaymentStatus(payment_status);

      //store the payment status in the database
      this.storePaymentStatus(isInvestmentId, investmentStatus);

      //clear the url location
      window.history.replaceState({}, '', pathname);
    }
  };

  handleChange = (tab) => {
    this.setState({
      tab,
    });
  };

  handleClose = () => {
    this.setState({ mainDialogOpen: true });
    return window.open('/', '_self');
  };
  handleClickOpen = () => {
    this.setState({ mainDialogOpen: false });
  };

  changeOfferPassStatus = () => {
    this.setState({ isOfferPasswordCorrect: true });
  };
  toggleInvestment = (
    event,
    investmentId = null,
    showAgreementStep = false
  ) => {
    this.setState({
      openInvestment: investmentId,
      showAgreementStep,
      openContinue: false,
    });
  };

  handleScroll = (e) => {
    if (window.pageYOffset > 443) {
      this.setState({ showPosition: true });
    } else {
      this.setState({ showPosition: false });
    }
  };

  showCountDown = (
    show,
    offer,
    tenant,
    title = 'This offer will be available in'
  ) => {
    const checkcountdowndiff =
      +new Date(`${offer.countDown}`) - +new Date() > 0;

    if (
      show &&
      (offer.typeOfOffer == 'REG_A' || offer.typeOfOffer == 'REG_CF') &&
      checkcountdowndiff
    ) {
      const MySwal = withReactContent(Swal);
      MySwal.fire({
        width: '50%',
        html: (
          <CountDown
            title={title}
            date={offer.countDown}
            dateTo='January 01, 2023 00:00:00 GMT+03:00'
          />
        ),
        showConfirmButton: false,
        cancelButtonColor: tenant.theme.primaryColor,
        cancelButtonText: 'Continue Browsing',
        showCancelButton: true,
      });
      this.setState({ showCountDown: false });
    }
  };

  showTabDetail = (
    isAuthenticated,
    tab,
    offer,
    issuerCompany,
    listingType,
    CompanyName,
    OfferName
  ) => {
    if (isAuthenticated) {
      switch (tab) {
        case 0:
          return listingType == 'FUNDS' ? (
            <OfferDetailsFund
              CompanyName={CompanyName}
              OfferName={OfferName}
              offer={offer}
            />
          ) : (
            <OfferDetails
              CompanyName={CompanyName}
              OfferName={OfferName}
              offer={offer}
            />
          );
          break;
        case 1:
          return (
            <OfferInvestments
              issuerCompany={issuerCompany}
              toggleInvestment={this.toggleInvestment}
            />
          );
        case 2:
          return (
            <Comment
              offer={offer}
              issuerCompany={issuerCompany}
              investorUser={this.props.investorUser}
              isAuthenticated={this.props.isAuthenticated}
            />
          );
        default:
          break;
      }
    }
    return null;
  };
  render() {
    const {
      tab,
      openInvestment,
      showbrokerageAgreementStep,
      showAgreementStep,
      showPaymentMethodStep,
      setPaymentSteps,
      stripeSessionId,
    } = this.state;

    const {
      data,
      investorUser,
      tenant,
      isAuthenticated,
      startedAccreditation,
      offerInvestmentsData,
    } = this.props;
    const isOfferAuth =
      !isAuthenticated &&
      (!typeOfOffer ||
        typeOfOffer == 'REG_D' ||
        typeOfOffer == 'Reg_D_506b' ||
        typeOfOffer == 'Reg_D_506c');

    if (data.loading) {
      return <Loading />;
    }

    const canViewOffers = isAuthenticated ? investorUser.canViewOffers : false;
    if (!localStorage.getItem('authToken')) {
      localStorage.setItem(
        'desiredRoute',
        `/offer/${this.props.match.params.id}`
      );
    }

    const offer = get(data, 'offer', data.offerAnon);

    if (!offer) {
      return <Redirect to='/' />;
    }
    this.showCountDown(this.state.showCountDown, offer, tenant);
    if (offer.offerPassword && localStorage.getItem('authToken')) {
      if (
        localStorage.getItem(
          `${localStorage.getItem('authToken')}${CRYPTO_COMPARE_KEY.concat(
            this.props.match.params.id
          )}`
        ) !==
        `${localStorage
          .getItem('authToken')
          .concat(this.props.match.params.id)}${CRYPTO_COMPARE_KEY}`
      ) {
        return (
          <OfferPwdAction
            open={!this.state.mainDialogOpen}
            handleChangeOfferPassStatus={this.changeOfferPassStatus}
            handleClickOpen={this.handleClickOpen}
            handleClose={this.handleClose}
            mutation={validateOfferPasswordMutation}
            title={'Private Offering'}
            offerId={this.props.match.params.id}
            isAuthenticated={isAuthenticated}
          />
        );
      }
    }

    const hasInvestment = isAuthenticated
      ? Boolean(offerInvestmentsData.offerInvestments) &&
        Boolean(offerInvestmentsData.offerInvestments.length)
      : false;

    if (isAuthenticated) {
      if (!canViewOffers) {
        return <Redirect to='/' />;
      }
      if (
        !hasInvestment &&
        (offer.status === 'PREMARKETING' ||
          offer.visibility === 'UNPUBLISHED' ||
          !offer.approved)
      ) {
        return <Redirect to='/' />;
      }
      if (localStorage.getItem('desiredRoute')) {
        localStorage.removeItem('desiredRoute');
      }
    } else if (
      offer.status === 'PREMARKETING' ||
      offer.visibility === 'UNPUBLISHED' ||
      !offer.approved
    ) {
      return <Redirect to='/' />;
    }

    const {
      _id: offerId,
      toggleDataRoom,
      dataRoomId,
      dataRoomGroupId,
      dataRoomCreated,
      hasJoinedWorkspace,
      videoFiles,
      documents,
      faqs,
      issuerCompany,
      headerImageUrl,
      headerType,
      headerVideoId,
      offerPresentationUrl,
      enableOfferPresentation,
      offerPresentationTitle,
      countDown,
      typeOfOffer,
      closingDate,
      listingType,
    } = offer;

    const isDataRoomEnabled = Boolean(
      toggleDataRoom || dataRoomId || dataRoomGroupId
    );
    const showVdrDebug =
      typeof window !== 'undefined' &&
      new URLSearchParams(window.location.search).get('debugVdr') === '1';

    const videoOptions = {
      width: 1200,
      height: 500,
      playerVars: {
        autoplay: 1,
        controls: 0,
        rel: 0,
        autohide: 1,
        showinfo: 0,
        origin: window.location.href,
        loop: 1,
        modestbranding: 0,
        mute: 1,
        fs: 1, // Hide the full screen button
        cc_load_policy: 1, // Hide closed captions
        iv_load_policy: 3, // Hide the Video Annotations
      },
    };

    if (headerVideoId && headerVideoId.includes('youtube')) {
      //Sort the videoId from youtube link using regex
      var regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = headerVideoId.match(regExp);
      var videoId = match && match[7].length == 11 ? match[7] : false;
    }

    //506b alternative name conditions
    const OfferTitle = isAuthenticated
      ? `${offer.name}`
      : `${offer.altOfferTitle}`;
    const BannerName = isAuthenticated
      ? `${issuerCompany.name}`
      : `${offer.altOfferTitle}`;

    const isCompanyName =
      offer.typeOfOffer === 'Reg_D_506b'
        ? BannerName
        : offer.issuerCompany.name;
    const isOfferName =
      offer.typeOfOffer === 'Reg_D_506b' ? OfferTitle : offer.name;
    const CompanyName = isCompanyName || offer.issuerCompany.name;

    const OfferName = isOfferName || offer.name;

    return (
      <Fragment>
        {!this.state.openContinue && openInvestment && (
          <PaymentProcessAction
            open={Boolean(openInvestment)}
            handleClose={this.toggleInvestment}
            offer={offer}
            investorUser={investorUser}
            investmentId={openInvestment}
            showAgreementStep={showAgreementStep}
            showbrokerageAgreementStep={showbrokerageAgreementStep}
            showPaymentMethodStep={showPaymentMethodStep}
            setPaymentSteps={setPaymentSteps}
            stripeSessionId={stripeSessionId}
          />
        )}
        {this.state.openContinue && (
          <PaymentProcessAction
            open={this.state.openContinue}
            handleClose={this.toggleInvestment}
            offer={offer}
            investorUser={investorUser}
            investmentId={openInvestment}
            showAgreementStep={showAgreementStep}
            showbrokerageAgreementStep={showbrokerageAgreementStep}
            showPaymentMethodStep={showPaymentMethodStep}
            setPaymentSteps={setPaymentSteps}
            stripeSessionId={stripeSessionId}
          />
        )}
        {headerType === 'IMAGE' || !headerType ? (
          <div
            className='hero-section-inner-page services'
            style={{
              backgroundImage: `linear-gradient(3deg, rgba(0, 0, 0, .14), rgba(51, 51, 51, .11) 25%, hsla(0, 0%, 100%, 0)), linear-gradient(180deg, rgba(12, 51, 97, .49), rgba(12, 51, 97, .49)), url(${headerImageUrl})`,
              backgroundPosition: 'center',
              marginTop: 65,
            }}
          >
            {isAuthenticated && <OfferFavorite tenant={tenant} offer={offer} />}
            <div className='hero-wrapper inner-page' data-ix='nav-scroll'>
              <h1 className='title' data-ix='home-title-animate-inner-page'>
                {CompanyName}
              </h1>
            </div>
          </div>
        ) : (
          <header>
            {videoId ? (
              <YoutubeBackground
                videoId={videoId}
                // aspectRatio='2.35.1'
                playerOptions={videoOptions}
                className='video-background'
              />
            ) : (
              <video
                playsInline='playsinline'
                autoPlay='autoplay'
                muted='muted'
                loop='loop'
              >
                <source src={headerVideoId} type='video/mp4' />
              </video>
            )}

            {isAuthenticated && (
              <OfferFavorite tenant={tenant} top={true} offer={offer} />
            )}
            <div className='hero-wrapper inner-page' data-ix='nav-scroll'>
              {/* <h1 className='title' data-ix='home-title-animate-inner-page'>
                {issuerCompany.name}
              </h1> */}
            </div>
          </header>
        )}
        {tab === 0 && (
          <div
            className={`nav-submenu ${
              this.state.showPosition ? 'positionAbs' : ''
            }`}
          >
            <nav
              className={`nav-menu-3 w-nav-menu res-nav ${
                this.state.showPosition ? 'positionFixed' : ''
              }`}
              style={{
                transform: 'translateY(0px) translateX(0px)',
                width: '100%',
                zIndex: 1000,
                // top: `${!isAuthenticated ? '80px' : '0px'}`,
                background: '#F0F0F0',
                transition: 'transform 400ms ease 0s',
              }}
            >
              <NavLinks
                to='#offerdetail'
                activeClassName='dash-current-page'
                className={`nav-link w-nav-link `}
                style={{ width: '10%' }}
              >
                Offer Details
              </NavLinks>

              <NavLinks
                to='#highlight'
                activeClassName='dash-current-page'
                className={`nav-link w-nav-link `}
                style={{ width: '10%' }}
              >
                Highlights
              </NavLinks>
              <NavLinks
                to='#company'
                activeClassName='dash-current-page'
                className={`nav-link w-nav-link `}
                style={{ width: '10%' }}
              >
                Company Summary
              </NavLinks>
              {Boolean(enableOfferPresentation && offerPresentationUrl) && (
                <NavLinks
                  to='#presentation'
                  activeClassName='dash-current-page'
                  className={`nav-link w-nav-link `}
                  style={{ width: '10%' }}
                >
                  Presentation
                </NavLinks>
              )}
              {Boolean(
                (documents && documents.length) ||
                  (videoFiles && videoFiles.length)
              ) && (
                <NavLinks
                  to='#documents'
                  activeClassName='dash-current-page'
                  className={`nav-link w-nav-link `}
                  style={{ width: '10%' }}
                >
                  Media
                </NavLinks>
              )}
              {Boolean(issuerCompany.users && issuerCompany.users.length) && (
                <NavLinks
                  to='#management'
                  activeClassName='dash-current-page'
                  className={`nav-link w-nav-link `}
                  style={{ width: '10%' }}
                >
                  Management Team
                </NavLinks>
              )}
              {Boolean(faqs && faqs.length) && (
                <NavLinks
                  to='#faq'
                  activeClassName='dash-current-page'
                  className={`nav-link w-nav-link `}
                  style={{ width: '10%' }}
                >
                  FAQ
                </NavLinks>
              )}
            </nav>
          </div>
        )}

        <div
          className='section'
          style={isAuthenticated ? { paddingBottom: 0 } : {}}
        >
          <div className='max-width-div'>
            {showVdrDebug && (
              <div
                style={{
                  marginBottom: 12,
                  padding: 12,
                  background: '#f7f7f7',
                  border: '1px solid #d9d9d9',
                  borderRadius: 4,
                  fontFamily: 'monospace',
                  fontSize: 12,
                  lineHeight: 1.4,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {`VDR DEBUG\nofferId: ${offerId}\nisAuthenticated: ${Boolean(
                  isAuthenticated
                )}\ntoggleDataRoom: ${Boolean(
                  toggleDataRoom
                )}\ndataRoomId: ${dataRoomId || ''}\ndataRoomGroupId: ${
                  dataRoomGroupId || ''
                }\ndataRoomCreated: ${Boolean(
                  dataRoomCreated
                )}\nisDataRoomEnabled: ${Boolean(
                  isDataRoomEnabled
                )}\nhasJoinedWorkspace: ${Boolean(hasJoinedWorkspace)}`}
              </div>
            )}
            {isAuthenticated && (
              <OfferListItems
                hasJoinedWorkspace={hasJoinedWorkspace}
                startedAccreditation={startedAccreditation}
                offerId={offerId}
                toggleDataRoom={isDataRoomEnabled}
                handleChange={this.handleChange}
                offer={offer}
                investorUser={investorUser}
                showCountDownState={this.state.showCountDown}
                tenant={tenant}
                activeTab={tab}
                offerPresentationUrl={offerPresentationUrl}
                showCountDown={this.showCountDown}
                countdownChecker={+new Date(`${countDown}`) - +new Date() > 0}
                closingDateChecker={
                  +new Date(`${closingDate}`) - +new Date() < 0
                }
              />
            )}
            {!isAuthenticated && (
              <AnonOfferListItems
                hasJoinedWorkspace={hasJoinedWorkspace}
                toggleDataRoom={isDataRoomEnabled}
                offer={offer}
                activeTab={tab}
              />
            )}
            {!isAuthenticated &&
              (!typeOfOffer ||
                typeOfOffer == 'REG_D' ||
                typeOfOffer == 'Reg_D_506b' ||
                typeOfOffer == 'Reg_D_506c') && (
                <AnonOfferDetails
                  OfferName={OfferName}
                  CompanyName={CompanyName}
                  offer={offer}
                />
              )}

            {this.showTabDetail(
              isAuthenticated,
              tab,
              offer,
              issuerCompany,
              listingType,
              CompanyName,
              OfferName
            )}

            {!isAuthenticated &&
              (typeOfOffer == 'REG_CF' || typeOfOffer == 'REG_A') &&
              (tab === 0 ? ( // notice first variable is not apart of ternary
                listingType == 'FUNDS' ? (
                  <OfferDetailsFund
                    CompanyName={CompanyName}
                    OfferName={OfferName}
                    offer={offer}
                  />
                ) : (
                  <OfferDetails
                    CompanyName={CompanyName}
                    OfferName={OfferName}
                    offer={offer}
                  />
                )
              ) : (
                <OfferInvestments
                  issuerCompany={issuerCompany}
                  toggleInvestment={this.toggleInvestment}
                />
              ))}
          </div>
        </div>
        {!isAuthenticated &&
          (!typeOfOffer ||
            typeOfOffer == 'REG_D' ||
            typeOfOffer == 'Reg_D_506b' ||
            typeOfOffer == 'Reg_D_506c') && <JoinOfferboardCTA />}
        <div
          className='section'
          style={
            ((isAuthenticated || !isAuthenticated) && !typeOfOffer) ||
            typeOfOffer == 'REG_CF' ||
            typeOfOffer == 'REG_A'
              ? { paddingTop: 0 }
              : {}
          }
        >
          <div className='sub-section' id='highlight'>
            {isOfferAuth && <AnonCompanyHighlights />}
            {!isAuthenticated &&
              (typeOfOffer == 'REG_CF' || typeOfOffer == 'REG_A') &&
              tab === 0 && <OfferHighlights offer={offer} />}
            {isAuthenticated && tab === 0 && <OfferHighlights offer={offer} />}
          </div>
          {tab === 0 && (
            <Fragment>
              <div className='sub-section' id='company'>
                <CompanySummary
                  isAuthenticated={isAuthenticated}
                  {...issuerCompany}
                />
              </div>

              <div className='sub-section' id='presentation'>
                {Boolean(enableOfferPresentation && offerPresentationUrl) && (
                  <OfferPresentation
                    isAuthenticated={isAuthenticated}
                    offerPresentationTitle={offerPresentationTitle}
                    offerPresentationUrl={offerPresentationUrl}
                  />
                )}
              </div>

              <div className='sub-section' id='documents'>
                {!isAuthenticated &&
                (!typeOfOffer ||
                  typeOfOffer == 'REG_D' ||
                  typeOfOffer == 'Reg_D_506b' ||
                  typeOfOffer == 'Reg_D_506c') ? (
                  <AnonOfferDocuments />
                ) : (
                  (Boolean(documents && documents.length) ||
                    Boolean(videoFiles && videoFiles.length)) && (
                    <div className='max-width-div add-margin'>
                      <OfferDocuments documents={documents} />
                      <OfferMedia videoFiles={videoFiles} />
                    </div>
                  )
                )}
              </div>

              {Boolean(issuerCompany.users.length) && (
                <div className='sub-section' id='management'>
                  <ManagementTeam users={issuerCompany.users} />
                </div>
              )}
              {Boolean(faqs && faqs.length) && (
                <div
                  id='faq'
                  className={
                    issuerCompany.users && issuerCompany.users.length
                      ? 'sub-section'
                      : 'grey-section'
                  }
                >
                  <OfferFAQs isAuthenticated={isAuthenticated} faqs={faqs} />
                </div>
              )}
            </Fragment>
          )}
        </div>
        <Footer tenant={tenant} />
      </Fragment>
    );
  }
}

OfferOverview.propTypes = {
  data: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  investorUser: PropTypes.object.isRequired,
  tenant: PropTypes.object.isRequired,
  startedAccreditation: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  updateViews: PropTypes.func,
  client: PropTypes.object,
  offerInvestmentsData: PropTypes.object,
  location: PropTypes.object.isRequired,
  currentInvestorUser: PropTypes.object,
  updateAgreementStatus: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
};

OfferOverview.defaultProps = {
  updateAgreementStatus: null,
  currentInvestorUser: {},
  updateViews: () => null,
  offerInvestmentsData: {},
};

const mapStateToProps = ({ investorUser, session, tenant }) => ({
  investorUser,
  tenant,
  isAuthenticated: session.isAuthenticated,
  startedAccreditation:
    investorUser.accreditationStatus === 'APPROVED' ||
    investorUser.accreditationStatus === 'EXEMPTED' ||
    investorUser.accreditationStatus === 'PENDING_APPROVAL',
});

const WithDataHOC = (ComponentToWrap) => (props) => {
  const { isAuthenticated } = props;

  const WithData = compose(
    graphql(isAuthenticated ? offerQuery : offerAnonQuery, {
      options: ({ match, tenant }) => ({
        variables: {
          _id: match.params.id,
          ...(!isAuthenticated && { tenantId: tenant._id }),
        },
      }),
    }),
    graphql(offerInvestmentsQuery, {
      name: 'offerInvestmentsData',
      options: ({ match }) => ({
        variables: {
          offerId: match.params.id,
        },
      }),
      skip: () => !isAuthenticated,
    }),
    graphql(updateInvestorOfferViews, {
      name: 'updateViews',
      options: ({ match }) => ({
        variables: {
          offerId: match.params.id,
        },
      }),
      skip: () => !isAuthenticated,
    }),
    graphql(submitInvestmentMutation, {
      name: 'updateAgreementStatus',
      skip: ({ location }) => {
        const params = new URLSearchParams(location.search);
        const investmentId = params.get('investmentId');
        const event = params.get('event');

        return !investmentId || !event;
      },
      options: ({ match, location }) => {
        const params = new URLSearchParams(location.search);
        const investmentId = params.get('investmentId');
        const event = params.get('event');
        const type = params.get('type');

        let status;

        switch (event) {
          case 'cancel':
            status = 'PENDING';
            break;
          case 'decline':
            status = 'DECLINED';
            break;
          case 'signing_complete':
            status = 'SIGNED';
            break;
          default:
            break;
        }

        if (type === 'subscription') {
          const input = {
            _id: investmentId,
            offerId: match.params.id,
            subscriptionAgreementStatus: status,
          };
          if (status === 'DECLINED') {
            input.agreementEnvelopeId = null;
          }
          return {
            variables: {
              input,
            },
          };
        } else if (type === 'brokerage') {
          const input = {
            _id: investmentId,
            offerId: match.params.id,
            brokerageAgreementStatus: status,
          };
          if (status === 'DECLINED') {
            input.brokerageAgreementEnvelopeId = null;
          }
          return {
            variables: {
              input,
            },
          };
        } else {
          const input = {
            _id: investmentId,
            offerId: match.params.id,
          };
          return {
            variables: {
              input,
            },
          };
        }
      },
    })
  )(ComponentToWrap);

  return <WithData {...props} />;
};

const OfferOverviewConnected = connect(mapStateToProps)(
  withApollo(WithDataHOC(OfferOverview))
);

export default withLayout(OfferOverviewConnected);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/index.js